﻿$.fn.dxCtrlBcBody = function custom_dxCtrlBcBody(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlbcbody dx-ctrl");
        this.createInstance(new cdxCtrlBcBody(this, option));
    }
    return this;
}

window.cdxCtrlBcBody = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            //dx.option(name, value);
        }
    }

    if (typeof option.appli == 'undefined') option.appli = null

    option.bddCtrl.mAddFunctionOnModifiedItemData(["bc_article"], container, function (action, itemData) {
        if (action == "supp") {
            if (option.elementBc != null && option.bddCtrl.getObjet(option.elementBc).mGetTable().nom == "bc_article") {
                if (option.elementBc.id_bc_dossier_parent == null) { option.onSelect(null) }
                else { option.onSelect(option.bddCtrl.getObjet("bc_dossier", option.elementBc.id_bc_dossier_parent).data) }
            }
        } else {
            if (option.elementBc != null && option.bddCtrl.getObjet(option.elementBc).mGetTable().nom == "bc_article" && option.elementBc.id_bc_article == itemData.id_bc_article) {
                option.onSelect(itemData)
                //if (option.elementBc.id_bc_dossier_parent == null) { option.onSelect(null) }
                //else { option.onSelect(option.bddCtrl.getObjet("bc_dossier", option.elementBc.id_bc_dossier_parent).data) }
            }
        }
    })

    var dxBcList = null
    function mConstruit() {
            dxBcList=null
        container.css("height", ((container.innerHeight() > 0) ? container.innerHeight() + 'px' : ''))
        container.empty();

        var $DivContainer = $("<div style='padding:0 30px;'/>").appendTo(container)

        $("<div style='padding:10px 20px;'/>").appendTo($DivContainer).dxCtrlBcArbo({
            bddCtrl: option.bddCtrl,
            txtSearch: option.txtSearch,
            elementBc: option.elementBc,
            readOnly: option.readOnly,
            appli:option.appli,
            onSelect: function (value) {
                option.onSelect(value)
            },
            onCreateNew: function (newElementBc) {
                option.onSelect(newElementBc)
            }
        })

        if (option.elementBc != null && option.bddCtrl.getObjet(option.elementBc).mGetTable().nom == "bc_article") {
            //on a un article
            $("<div/>").appendTo($DivContainer).dxCtrlBcArticle({
                bddCtrl: option.bddCtrl,
                elementBc: option.elementBc,
                readOnly: option.readOnly,
                appli: option.appli,
                onDelete: function (bcArticle) {
                    if (bcArticle.id_bc_dossier_parent == null) { option.onSelect(null) }
                    else { option.onSelect(option.bddCtrl.getObjet("bc_dossier", bcArticle.id_bc_dossier_parent).data) }
                }
            })
        } else {
            //dossier//recherche//accueil
            dxBcList = $("<div/>").appendTo(container).dxCtrlBcListe({
                bddCtrl: option.bddCtrl,
                txtSearch: option.txtSearch,
                appli: option.appli,
                elementBc: option.elementBc,
                readOnly: option.readOnly,
                onSelect: function (value) { option.onSelect(value) }
            }).dxCtrlBcListe("instance")
        }
        //if (!gestCognoss.isAdmin()) {
        //    if (option.elementBc != null) {
        //        var urlLink = option.bddCtrl.getObjet(option.elementBc).objetMetier.mGetLink()
        //        //history.pushState({ foo: 'bar' }, parametre.nom, urlLink);
        //    } else {
        //        //history.pushState({ foo: 'bar' }, parametre.nom, gestCognoss.mGetAppliCourante().urlcognoss);
        //    }
        //}

        container.css("height", "")
    }

    this.export = function () {
        dxBcList.export()
    }

    this.mReload = function () {
        mConstruit()
    }

    this.element = function () { return container; }

    mConstruit();
}